import Reveal from "./Reveal";

export default function SectionHeader({ number, eyebrow, title, description, dark = false, align = "left" }) {
  return (
    <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <p
          data-testid={`section-eyebrow-${(eyebrow || "").toLowerCase().replace(/\s+/g, "-")}`}
          className={`flex items-center gap-3 text-xs sm:text-sm font-semibold tracking-[0.25em] uppercase ${
            dark ? "text-teal-300" : "text-brand"
          } ${align === "center" ? "justify-center" : ""}`}
        >
          {number && <span className="font-heading text-base opacity-60">{number}</span>}
          <span className={`h-px w-8 ${dark ? "bg-teal-300/50" : "bg-brand/40"}`} />
          {eyebrow}
        </p>
      )}
      <h2
        className={`mt-4 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-balance ${
          dark ? "text-white" : "text-navy"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p className={`mt-4 text-base sm:text-lg leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}>
          {description}
        </p>
      )}
    </Reveal>
  );
}
